module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "leftnavbar"
    }
  }, [_c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "logo"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/home"
    }
  }), _vm._v("\n\t\t\tHjem\n\t\t")], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isClient()
    },
    on: {
      "click": function($event) {
        return _vm.setView('/clients')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/users"
    }
  }), _vm._v("\n\t\t\tKunder\n\t\t")], 1), _vm._v(" "), (false) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isProject()
    },
    on: {
      "click": function($event) {
        return _vm.setView('/projects')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/rocket"
    }
  }), _vm._v("\n\t\t\tOpgaver\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.show_beta_content) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/timeline'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/timeline')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-calendar-outline"
    }
  }), _vm._v("\n\t\t\tTimeline\n\t\t")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isTimelogs()
    },
    on: {
      "click": function($event) {
        return _vm.setView('/timelogs')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/pie-chart"
    }
  }), _vm._v("\n\t\t\tTidsforbrug\n\t\t")], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isTimelogger()
    },
    on: {
      "click": function($event) {
        return _vm.openTimelogger()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-clock-outline"
    }
  }), _vm._v("\n\t\t\tLog tid\n\t\t")], 1), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isEconomy()
    },
    on: {
      "click": function($event) {
        return _vm.setView('/economy')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/briefcase"
    }
  }), _vm._v("\n\t\t\tØkonomi\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.is_user('wp') && _vm.economy_access) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/specs'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/specs')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/list"
    }
  }), _vm._v("\n\t\t\tSpecs\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.show_beta_content) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/users'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/users')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/users"
    }
  }), _vm._v("\n\t\t\tUsers\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/reports'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/reports')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/users"
    }
  }), _vm._v("\n\t\t\tRapporter\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.show_beta_content) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/kitchensink'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/kitchensink')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/magic-wand"
    }
  }), _vm._v("\n\t\t\tKitchen Sink\n\t\t")], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "logged-in-area"
    }
  }, [_c('avatar', {
    attrs: {
      "input": _vm.my_user
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setView('/my-settings')
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "logoutbtn"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_vm._v("Log ud")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0dea3ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Leftnavbar.vue
// module id = 618
// module chunks = 1